window.addEventListener("load", () => {
  setTimeout(() => {
    document.querySelector(".js-loading")
      ?.classList.add("is-hide");
  }, 1800);
});